import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';

export interface QuestionWithSuggestions {
  question: string;
  suggestions: string[];
}

/**
 * Custom hook for generating context questions based on user input
 */
export function useDeepSearchQuestionsMutation() {
  return useMutation<QuestionWithSuggestions[], Error, string>({
    mutationFn: async (input: string) => {
      const response = await FetchPromise.post('/deep-research/context-question', {
        input,
      });
      if (!response) {
        throw new Error('Failed to generate context questions');
      }

      // The response will contain questions in the new format with suggestions
      return response.questions;
    },
  });
}
